// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__3epp7","title":"ClientReferral_title__2MKGN","itemText":"ClientReferral_itemText__1mf-E"};